import { render, staticRenderFns } from "./Error.vue?vue&type=template&id=3c6fb383&scoped=true"
var script = {}
import style0 from "./Error.vue?vue&type=style&index=0&id=3c6fb383&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6fb383",
  null
  
)

export default component.exports